import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../features/shell/WorkspaceShell";

export const Route = createFileRoute("/w/$ws")({
  component: () => <WorkspaceShell wsKey={Route.useParams().ws} />,
});
